import type { ISerialize } from '@/objects/ISerialize';
import { Race } from './Race';
import { HeatPlan } from './HeatPlan';

export class CreateHeatPlanRequest implements ISerialize {
    public newRaces: Race[];

    public plans: HeatPlan[];

    public stationForFinishNewRaces: number | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { newRaces?: Race[]; plans?: HeatPlan[]; stationForFinishNewRaces?: number | null }) {
        this.newRaces = values.newRaces ?? [];

        this.plans = values.plans ?? [];

        this.stationForFinishNewRaces = values.stationForFinishNewRaces ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"newRaces": [ ${this.newRaces.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"plans": [ ${this.plans.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"stationForFinishNewRaces": ${JSON.stringify(this.stationForFinishNewRaces)}` +
            '}'
        );
    }

    /**
     * Creates an instance of CreateHeatPlanRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        newRaces?: Race[];
        plans?: HeatPlan[];
        stationForFinishNewRaces?: number | null;
    }): CreateHeatPlanRequest {
        return new CreateHeatPlanRequest(values);
    }

    public static _FromServerJson(json: any): CreateHeatPlanRequest {
        return new CreateHeatPlanRequest({
            newRaces: json.newRaces?.map((x: any) => Race._FromServerJson(x)),
            plans: json.plans?.map((x: any) => HeatPlan._FromServerJson(x)),
            stationForFinishNewRaces: json.stationForFinishNewRaces ?? null,
        });
    }

    /**
     * Creates an instance of CreateHeatPlanRequest from another instance of CreateHeatPlanRequest.
     * @param other The CreateHeatPlanRequest you want to clone
     * @returns A cloned CreateHeatPlanRequest
     */
    public static FromOther(other: CreateHeatPlanRequest): CreateHeatPlanRequest {
        return CreateHeatPlanRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return CreateHeatPlanRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'CreateHeatPlanRequest';
}
